import FundInvestments from "./FundInvestments";
import FundInvestments_Details from "./FundInvestments_Details";

const fundInvestments = {
    FundInvestments,
    FundInvestments_Details
}

export default fundInvestments;